import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAtom } from "jotai";
import { Helmet } from "react-helmet-async";
import { emailAtom, emailValidAtom } from "@/store/atoms";
import { useAuth } from "common/hooks";
import { AuthModalScreen, useAuthModals } from "@/hooks/useAuthModals";
import Loader from "@/components/common/Loader";

export const Route = createFileRoute("/login/$email")({
  component: Login,
});

function Login() {
  const navigate = useNavigate({ from: "/" });
  const { isLoading, isFetching, isLoggedIn } = useAuth();
  const isAuthLoading = isLoading || isFetching;
  const { showModal } = useAuthModals();
  const [, setEmail] = useAtom(emailAtom);
  const [, setEmailValid] = useAtom(emailValidAtom);
  const { email } = Route.useParams();

  // Decode the URL-encoded user parameter
  const decodedUserEmail = decodeURIComponent(email);

  useEffect(() => {
    if (isLoggedIn) {
      //redirect to home page
      navigate({ to: "/" });
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    if (!isLoading && !isFetching && !isLoggedIn && decodedUserEmail) {
      setEmail(decodedUserEmail);
      setEmailValid(true);

      showModal(AuthModalScreen.EnterEmail);

      //redirect to home page
      navigate({ to: "/" });
    }
  }, [
    decodedUserEmail,
    isFetching,
    isLoading,
    isLoggedIn,
    navigate,
    setEmail,
    setEmailValid,
    showModal,
  ]);

  return (
    <>
      <Helmet>
        <title>Sign In | Sociability</title>
      </Helmet>
      {isAuthLoading && <Loader />}
    </>
  );
}
